<script lang="ts" module>
  import type { Snippet } from 'svelte';
  import type { UseCollapsibleProps } from '../use-collapsible.svelte';

  export interface CollapsibleRootProps extends UseCollapsibleProps {
    children?: Snippet;
    open?: boolean;
  }
</script>

<script lang="ts">
  import { useCollapsible } from '../use-collapsible.svelte';
  import { CollapsibleProvider } from '../use-collapsible-context';

  const id = $props.id();
  const { open, children, ...props }: CollapsibleRootProps = $props();

  const collapsible = useCollapsible({ ...props, id });
  CollapsibleProvider(collapsible);

  $effect(() => {
    if (open !== undefined) {
      collapsible.api.setOpen(open);
    }
  });
</script>

<div {...collapsible.api.getRootProps()}>
  {#if children}
    {@render children()}
  {/if}
</div>
